import { observer } from 'mobx-react-lite'
import { forwardRef } from 'react'
import { useTreeState } from '../../../stores/Root'
import { undoManager } from '../../../stores/StudioStore'
import { Row } from '../../core/Components'
import InstrumentLoop from '../loops/InstrumentLoop'

interface InstrumentTrackStemProps {
  loopColor: string
  height: string
  stemID: string
  trackHeight: string
  instrumentLoopWidthPX: number
}

const InstrumentTrackStem = (
  { loopColor, height, stemID, trackHeight, instrumentLoopWidthPX }: InstrumentTrackStemProps,
  ref: React.Ref<HTMLDivElement>
) => {
  const { studio } = useTreeState()
  const song = studio.song
  const stemIndex = studio.song.getStemIndexByID(stemID)

  return (
    <Row
      style={{
        height: height
      }}
      ref={ref}
    >
      {Array.from(Array(song.songDisplayLength + studio.extraBarsCount).keys()).map(
        (item, section) => (
          <InstrumentLoop
            onClick={() => {
              undoManager.startGroup(() => {
                studio.setSelectedStemIndex(stemIndex)
                studio.setSelectedSection(section)
                undoManager.stopGroup()
              })
            }}
            stemIndex={stemIndex}
            section={section}
            loopColor={loopColor}
            loopNumber={song.getLoopIndex(stemIndex, section)}
            updateSong={(newValue) => {
              song.updateLoopForStem(stemIndex, section, newValue)
            }}
            trackHeight={trackHeight}
            key={section}
            instrumentLoopWidthPX={instrumentLoopWidthPX}
          />
        )
      )}
    </Row>
  )
}

export default observer(forwardRef(InstrumentTrackStem))
